import type { ComponentProps, ImageComponent } from '@enonic/react-components'
import type { RichTextData } from '@enonic/react-components'
import { RichText } from '@enonic/react-components'
import * as React from 'react'

export interface ProseProps {
  data: RichTextData
  meta: ComponentProps['meta']
  common?: ComponentProps['common']
  component?: ComponentProps['component']
  className?: string
}

// Plain <img> replacement for inline rich-text images. Bypasses the library's
// default Image, which wraps each img in a Suspense boundary that lazy-imports
// an ErrorBoundary client chunk — that chunk fails to load inside Content
// Studio's edit-mode iframe, leaving inline images blank.
const PlainImage: ImageComponent<{loading?: 'lazy' | 'eager'}> = ({
  alt,
  sizes,
  src,
  srcSet,
  style,
  loading,
}) => (
  <img
    alt={alt ?? ''}
    sizes={sizes}
    src={src}
    srcSet={srcSet}
    style={style}
    loading={loading}
  />
)

export const Prose = ({
  data,
  meta,
  common,
  component,
  className,
}: ProseProps) => {
  return (
    <div className={`site-prose ${className ?? ''}`.trim()}>
      <RichText
        tag="div"
        data={data}
        meta={meta}
        common={common}
        component={component}
        Image={PlainImage}
        loading="lazy"
      />
    </div>
  )
}
